<template>
  <v-container>
    <h1>Conversiones Disponibles</h1>
    <v-row class="ma-0">
      <v-col class="pa-0 my-4">
        <v-text-field
          v-model="busqueda"
          placeholder="Buscar"
          clearable
          hide-details
          outlined
          style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
          prepend-inner-icon="mdi-magnify"
        />
      </v-col>
      <v-col class="d-flex justify-end pa-0 my-4">
        <v-btn color="black" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSXActiveConversions()">
          <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
          {{ "Descargar" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="isLoading" />
    <v-data-table class="d-none d-sm-block" :items-per-page="10" v-else hide-default-header :items="filteredActiveConversions" style="background-color: white !important">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">{{ "Id" }}</th>                                                                                                                                                                                  
            <th class="header__title center">{{ "Fecha de creación" }}</th>
            <th class="header__title center">{{ "Tipo de transaccion" }}</th>                                                                                                                                                              
            <th class="header__title center">{{ "Monto origen" }}</th>
            <th class="header__title center">{{ "Monto destino" }}</th>                                                                                                                                                                                                                       
            <th class="header__title center">{{ "Tipo de cambio" }}</th>
            <th class="header__title right">{{ "Acciones" }}</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">{{ item.sTransactionId }}</td>
            <td class="table__item">{{ formatDate(item.created_at) }}</td>
            <td class="table__item">
              <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" class="ma-2" color="red" outlined style="background-color: #FDF0F5 !important; border-width: 1.5px;">
                {{ "Forward" }}
              </v-chip>
              <v-chip v-else-if="item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" class="ma-2" color="#2397C7" outlined style="background-color: #F0F8FE !important; border-width: 1.5px;">
                {{ "Spot" }}
              </v-chip>
              <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" class="ma-2" color="#FB0075" outlined style="background-color: #FDEBEB !important; border-width: 1.5px;">
                {{ "Window spot" }}
              </v-chip>
            </td>
            <td class="table__item">{{ "$ " + formatMoney(item.dAmount) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</td>
            <td class="table__item">{{ "$ " + formatMoney(item.dDesAmount) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</td>
            <td class="table__item">{{  "$ " + formatMoney(item.dExchangeRate < 1 ? 1 / item.dExchangeRate : item.dExchangeRate) + " MXN" }}</td>
            <td class="table__item">
              <v-btn :disabled="!permissionList.includes('createPayment')" color="black" elevation="3" style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;" outlined @click="getSuppliers(), dialogSendPayWithTransaction = true, availableAmount = item.dDesAmount, sTransactionId = item.sTransactionId, selectedCurrency = item.sDestCurrency">
                <v-icon left>mdi mdi-file-document-plus-outline</v-icon>
                {{ "Pagar" }}
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-dialog v-if="dialogSendPayWithTransaction" v-model="dialogSendPayWithTransaction" max-width="680" style="margin: auto;" persistent class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header v-if="e1 < 3" color="Black" class="mt-5 mr-15 ml-15" elevation="0" 
            style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;"
          >
            <v-stepper-step :complete="e1 > 1" step="1" color="black"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="black"></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" elevation="0" class="pt-0" style="">
              <v-container class="mt-1">
                <v-card elevation="0" style="max-width: 680px;">
                  <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                    <span style="font-family: 'montserrat-bold'; font-size: 28px; color: black;">
                      {{ "Crear Pago" }}
                    </span>
                  </v-card-title>
                  <v-card-text class="py-6 px-4 pt-0">
                    <!-- Wallet Origen -->
                    <div>
                      <v-row class="">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Selecciona la wallet origen" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col v-if="selectedCurrency == 'USD'">
                          <v-card  class="d-flex" outlined @click="selectedCurrency = 'USD', exchangeRateToday = '', exchangeRateTodayReference = '',  amounts = { USD: 0, MXN: 0 }, supplier = null, selected = null, selectedTypeOfPayment = null, comment = ''" elevation="2"
                            style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 100%;"
                          >
                            <div class="pa-2" style="display: flex; align-items: flex-start; justify-content: space-between;">
                              <div>
                                <div style="margin-right: 30px">
                                  <v-img src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                                  <div style="font-family: 'montserrat-bold';">{{ "Wallet USD" }}</div>
                                </div>
                              </div>
                              <v-icon v-if="selectedCurrency === 'USD'" color="black">mdi-check-circle</v-icon>
                              <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                            </div>
                            <div class="pa-2">
                              <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                                ${{ formatMoney(availableAmount) }} USD
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-card class="d-flex" outlined @click="selectedCurrency = 'MXN', exchangeRateToday = '', exchangeRateTodayReference = '', amounts = { USD: 0, MXN: 0 }, supplier = null, selected = null, selectedTypeOfPayment = null, comment = ''" elevation="2"
                            style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between;"
                          >
                            <div class="pa-2" style="display: flex; align-items: flex-start; justify-content: space-between;">
                              <div>
                                <div style="margin-right: 30px">
                                  <v-img src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                                  <div style="font-family: 'montserrat-bold';">{{ "Wallet MXN" }}</div>
                                </div>
                              </div>
                              <v-icon v-if="selectedCurrency === 'MXN'" color="black">mdi-check-circle</v-icon>
                              <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                            </div>
                            <div class="pa-2">
                              <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                                ${{ formatMoney(availableAmount) }} MXN
                              </div>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>

                    <!-- Supplier -->
                    <div v-if="selectedCurrency">
                      <v-row class="mt-0">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Selecciona el destinatario" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col>
                          <v-autocomplete
                            :items="suppliers"
                            filled
                            rounded
                            label="Contactos"
                            item-text="sNameAC"
                            return-object
                            v-model="selected"
                            @change="supplier = selected"
                            hide-details
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                    </div>

                    <!-- TC -->
                    <div v-if="selectedCurrency && supplier ? (selectedCurrency != (supplier?.sAccountCurrency)) : false">
                      <v-row class="mt-0">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Ingresa el UUID del TC o genera uno" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0" style="display: flex; align-items: center;">
                        <v-col>
                          <v-text-field
                            v-model="exchangeRateTodayReference"
                            filled
                            @change="calculatorAmount(amounts[selectedCurrency], false, selectedCurrency, supplier?.sAccountCurrency)"
                            :disabled="selectedCurrency === null"
                            :loading="isLoadingRate"
                            rounded
                            style="min-width: 100px;"
                            label="Ingresa el UUID"
                            hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-btn
                            color="black"
                            class="py-5 white--text"
                            elevation="2"
                            rounded
                            :loading="isLoadingRate"
                            block
                            @click="getRate(selectedCurrency, supplier?.sAccountCurrency)"
                          >
                            <span style="font-family: 'montserrat-semibold';">{{ "Generar UUID" }}</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                      <v-col>
                        <div class="info-block" style="width: 100%; display: flex; flex-direction: column; align-items: center;">
                          <p class="label">Tipo de cambio:</p>
                          <p class="value" v-if="exchangeRateTodayReference">{{ "$" + exchangeRateToday + " MXN" }}</p>
                        </div>
                      </v-col>
                    </v-row>
                    </div>

                    <!-- Montos -->
                    <div v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : true)) : false">
                      <v-row class="mt-0">
                        <v-col>
                          <h4 class="mt-3" style="font-family: 'montserrat-bold';">{{ "Ingresa el monto a pagar" }}</h4>
                        </v-col>
                      </v-row>
                      <v-row class="mt-0">
                        <v-col>
                          <v-text-field
                            outlined
                            :label="`De ${currencyMap[selectedCurrency]?.name}`"
                            type="number"
                            dense
                            :loading="isLoadingRate"
                            :disabled="selectedCurrency != (supplier?.sAccountCurrency) ? isLoadingRate : false"
                            hide-details
                            v-model="amounts[selectedCurrency]"
                            @change="selectedCurrency != (supplier?.sAccountCurrency) ? calculatorAmount(amounts[selectedCurrency], false, selectedCurrency, supplier?.sAccountCurrency) : null"
                            prefix="$"
                          >
                            <template v-slot:append>
                              <div class="d-flex align-center">
                                <img
                                  :src="currencyMap[selectedCurrency]?.flag"
                                  width="24"
                                  height="24"
                                  alt=""
                                  class="rounded"
                                />
                                <h4 class="ml-2 font-weight-bold">{{ selectedCurrency }}</h4>
                              </div>
                            </template>
                          </v-text-field>
                          <v-text-field
                            outlined
                            :label="`A ${currencyMap[supplier?.sAccountCurrency]?.name}`"
                            type="number"
                            dense
                            hide-details
                            :loading="isLoadingRate"
                            v-if="selectedCurrency != (supplier?.sAccountCurrency)"
                            :disabled="selectedCurrency != (supplier?.sAccountCurrency) ? isLoadingRate : false"
                            v-model="amounts[supplier?.sAccountCurrency]"
                            @change="(calculatorAmount(amounts[supplier?.sAccountCurrency], true, selectedCurrency, supplier?.sAccountCurrency))"
                            prefix="$"
                            class="mt-4"
                          >
                            <template v-slot:append>
                              <div class="d-flex align-center">
                                <img
                                  :src="currencyMap[supplier?.sAccountCurrency]?.flag"
                                  width="24"
                                  height="24"
                                  alt=""
                                  class="rounded"
                                />
                                <h4 class="ml-2 font-weight-bold">{{ supplier?.sAccountCurrency }}</h4>
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </div>

                    <!-- Detalle de montos -->
                    <div class="py-6" v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : true)) : false">
                      <v-row class="align-center">
                        <v-col>
                          <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                            {{ "Total origin" }}
                          </div>
                        </v-col>
                        <v-col class="d-flex justify-end">
                          <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold';">
                            ${{ amounts[selectedCurrency] ? formatMoney(amounts[selectedCurrency]) : 0 }} {{ selectedCurrency }}
                          </h2>
                        </v-col>
                      </v-row>
                      <v-row class="align-center mt-0">
                        <v-col>
                          <div style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold'; color: black;">
                            {{ selectedCurrency == (supplier?.sAccountCurrency) ? "Cantidad a enviar" : "Total destination" }}
                          </div>
                        </v-col>
                        <v-col class="d-flex justify-end">
                          <h2 class="text-black" style="text-wrap: nowrap; font-size: 18px; font-family: 'montserrat-bold';">
                            ${{ amounts[supplier?.sAccountCurrency] ? formatMoney(amounts[supplier?.sAccountCurrency]) : 0 }} {{ supplier?.sAccountCurrency }}
                          </h2>
                        </v-col>
                      </v-row>
                    </div>

                    <div class="info-block" v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : true)) : false">
                      <v-textarea
                        class="pa-4"
                        rows="2"
                        :label="'Concepto de pago'"
                        v-model="comment"
                        no-resize
                        hide-details
                      ></v-textarea>
                    </div>

                    <!-- Spot o Window Spot -->
                    <div v-if="selectedCurrency && supplier ? ((selectedCurrency != (supplier?.sAccountCurrency) ? exchangeRateToday : false)) : false">
                      <v-row class="mt-0">
                        <v-col>
                          <v-card class="d-flex pa-2 mb-3" @click="selectedTypeOfPayment = 'Spot'" elevation="2" style="background-color: #F2F2F2; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; height: 100%;">
                            <div>
                              <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 18px;">{{ "Pago instantaneo" }}</div>
                              <div style="font-family: 'montserrat-bold'; font-size: 14px; color: #737583">
                                {{ "Al utilizar pago instantaneo se descontara del balance origen y se enviara a la wallet destino." }}
                              </div>
                            </div>
                            <v-icon v-if="selectedTypeOfPayment === 'Spot'" color="black">mdi-check-circle</v-icon>
                            <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                          </v-card>
                        </v-col>
                        <v-col>
                          <v-card class="d-flex pa-2" @click="selectedTypeOfPayment = 'Window Spot'" elevation="2" style="background-color: #F2F2F2; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; height: 100%;">
                            <div>
                              <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 18px;">{{ "Pago diferido" }}</div>
                              <div style="font-family: 'montserrat-bold'; font-size: 14px; color: #737583">
                                {{ "Al utilizar pago diferido se creara un window spot y le permitira depositar el monto origen y una vez se refleje se enviara a tu destinatario." }}
                              </div>
                            </div>
                            <v-icon v-if="selectedTypeOfPayment === 'Window Spot'" color="black">mdi-check-circle</v-icon>
                            <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                          </v-card>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card-text>
                  <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                    <v-btn
                      elevation="4"
                      class="mr-2 px-10"
                      style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                      outlined
                      @click="selectedCurrency = null, dialogSendPayWithTransaction = false, sTransactionId = null, selected = null, supplier = null, amounts = { USD: 0, MXN: 0 }, exchangeRateToday = '', exchangeRateTodayReference = '', selectedTypeOfPayment = null, comment = ''"
                    >
                      {{ "Cancel" }}
                    </v-btn>
                    <v-btn
                      color="black"
                      elevation="4343"
                      class="white--text px-10"
                      style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                      :loading="loading"
                      :disabled="selectedCurrency === null || amounts[selectedCurrency] == 0 || amounts[supplier?.sAccountCurrency] == 0 || (selectedCurrency != (supplier?.sAccountCurrency) ? selectedTypeOfPayment == null : false) || comment == '' || parseFloat(amounts[selectedCurrency]) > parseFloat(availableAmount)"
                      @click="e1 = 2"
                    >
                      {{ "Next" }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" class="pt-0">
              <v-card class="pa-6 mx-auto">
                <v-card-text class="pb-0 px-0" >
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ supplier?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="supplier">
                        <p class="label">Número de cuenta:</p>
                        <p class="value" >{{ "*" + (supplier ? (supplier?.sAccountNumber ? (supplier?.sAccountNumber).slice(-4) : (supplier?.accountNumber).slice(-4)) : '') }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else style="align-items: center;">
                          <v-chip v-if="selectedTypeOfPayment == 'Spot'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Spot" }}
                          </v-chip>
                          <v-chip v-else-if="selectedTypeOfPayment == 'Window Spot'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de pago:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Window Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[selectedCurrency]) + " " + selectedCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">El destinatario recibira:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[supplier?.sAccountCurrency]) + " " + (supplier?.sAccountCurrency) }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Payment concept:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ comment }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="e1 = 1"
                  >
                    {{ "Back" }}
                  </v-btn>
                  <v-btn
                    color="black"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    @click="sendPayment(), e1 = 3"
                  >
                    {{ "Confirm" }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3" class="pt-0">
              <v-btn icon @click="dialogSendPayWithTransaction = false, sTransactionId = null, selectedCurrency = null, selected = null, selectedTypeOfPayment = '', comment = '', amounts = { MXN: null, USD: null }, paymentError = false, loadingPayment = false, getAvailableConversions(), e1 = 1" :disabled="loadingPayment" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-card class="pa-6 mx-auto">
                <div v-if="loadingPayment" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando pago...</p>
                </div>
                <div v-if="paymentError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ selectedTypeOfPayment === 'Window Spot' ? "Pago programado correctamente!" : "Pago procesado correctamente!" }}
                  </v-card-title>
                </div>
                <div v-if="paymentError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al procesar el pago!
                  </v-card-title>
                </div>
                <v-card-text class="pb-0 px-0">
                  <v-card class="info-card">
                    <div class="info-block">
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Cliente:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ supplier?.sName }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;" v-if="supplier">
                        <p class="label">Número de cuenta:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "*" + (supplier ? ((supplier?.accountNumber ? (supplier?.accountNumber).slice(-4) : (supplier?.sAccountNumber).slice(-4))) : '') }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de transacción:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else style="align-items: center;">
                          <v-chip v-if="selectedTypeOfPayment == 'Spot'" color="#2397C7" style="background-color: #F0F8FE !important;" outlined>
                            {{ "Forex" }}
                          </v-chip>
                          <v-chip v-else-if="selectedTypeOfPayment == 'Window Spot'" color="#FB0075" style="background-color: #FDEBEB !important;" outlined>
                            {{ "Window spot" }}
                          </v-chip>
                        </p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha de pago:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ paymentDay }}</p>
                      </div>
                      <div v-if="selectedTypeOfPayment === 'Window Spot'" style="display: flex; justify-content: space-between;">
                        <p class="label">Fecha limite:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ limitWindowSpot }}</p>
                      </div>
                    </div>
                    <div class="info-block mb-0">
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Tipo de cambio:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + (exchangeRateToday < 1 ? (1 / exchangeRateToday).toFixed(2) : exchangeRateToday?.toFixed(2)) + " MXN" }}</p>
                      </div>
                      <div v-if="selectedCurrency != (supplier?.sAccountCurrency)" style="display: flex; justify-content: space-between;">
                        <p class="label">Monto origen:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[selectedCurrency]) + " " + selectedCurrency }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">El destinatario recibira:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ "$ " + formatMoney(amounts[supplier?.sAccountCurrency]) + " " + (supplier?.sAccountCurrency) }}</p>
                      </div>
                      <div style="display: flex; justify-content: space-between;">
                        <p class="label">Payment concept:</p>
                        <v-skeleton-loader v-if="loadingPayment" type="text" width="150" height="20" class="value"/>
                        <p class="value" v-else>{{ comment }}</p>
                      </div>
                    </div>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import * as XLSX from "xlsx";
  import { saveAs } from "file-saver";
  import moment from "moment";
  export default {
    name: "ConversionesDisponibles",
    props: {
      activeTab: String,
      permissionList: Array,
      enterprise: Object
    },
    data() {
      return {
        activeConversionsRaw: [],
        busqueda: "",
        isLoading: false,
        isLoadingRate: false,
        payment: null,
        loadingPayment: false,
        exchangeRateToday: null,
        comment: null,
        loading: false,
        paymentError: null,
        dialogSendPayWithTransaction: false,
        selectedConversion: null,
        availableAmount: null,
        sTransactionId: null,
        paymentDay: null,
        selectedCurrency: null,
        limitWindowSpot: null,
        suppliers: [],
        isLoadingSuppliers: false,
        exchangeRateTodayReference: null,
        e1: null,
        selected: null,
        supplier: null,
        selectedTypeOfPayment: null,
        amounts: { USD: 0, MXN: 0 },
        currencyMap: {
          USD: { name: "Dólares Estadounidenses", flag: require("../../assets/images/Flags_usa.svg") },
          MXN: { name: "Pesos Mexicanos", flag: require("../../assets/images/Flags_mex.svg") },
        },
      };
    },
    watch: {
      activeTab(val) {
        if (val === 'conversionesDisponibles') {
          this.getAvailableConversions();
        }
      }
    },
    computed: {
      filteredActiveConversions() {
        if (!this.busqueda) return this.activeConversionsRaw;

        const filtro = this.busqueda.toLowerCase();

        return this.activeConversionsRaw.filter((item) => {
          const tipo = this.getTransactionTypeName(item.sTransactionType).toLowerCase();
          const fecha = this.formatDate(item.created_at).toLowerCase();
          const montoOrigen = `$ ${this.formatMoney(item.dAmount)} ${item.sCurrency || 'USD'}`.toLowerCase();
          const montoDestino = `$ ${this.formatMoney(item.dDesAmount)} ${item.sDestCurrency || 'MXN'}`.toLowerCase();
          const tipoCambio = `$ ${this.formatMoney(item.dExchangeRate < 1 ? 1 / item.dExchangeRate : item.dExchangeRate)} MXN`.toLowerCase();

          return (
            String(item.iTrackingId).toLowerCase().includes(filtro) ||
            fecha.includes(filtro) ||
            tipo.includes(filtro) ||
            montoOrigen.includes(filtro) ||
            montoDestino.includes(filtro) ||
            tipoCambio.includes(filtro)
          );
        });
      }
    },
    mounted() {
      if (this.activeTab === 'conversionesDisponibles') {
        this.getAvailableConversions();
        this.paymentDay = moment().format("YYYY-MM-DD");
        this.limitWindowSpot = moment().add(7, "day").format("MMMM DD, YYYY");
      }
    },
    methods: {
      getAvailableConversions() {
        this.isLoading = true;
        DB.get(`${URI}/api/v1/en/administrator/conversions/${this.$route.params.sEnterpriseId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.activeConversionsRaw = response.data.transactions;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      getSuppliers() {
        this.isLoadingSuppliers = true;
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };

        DB.post(`${URI}/api/v1/en/administrator/suppliers`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
          .then((response) => {
            this.isLoadingSuppliers = false;
            this.suppliers = response.data.paymentRecipients;
            this.suppliers.map((item) => {
              item.sNameAC = item.sName + " - *******" + (item.sAccountNumber ? item.sAccountNumber.slice(-4) : item.accountNumber.slice(-4)) + " - (" + item.sAccountCurrency + ")";
            });
          })
          .catch((error) => {
            this.isLoadingSuppliers = false;
            this.mixError(error.response.data.message, error.response.status);
          });
      },
      async calculatorAmount(amount, reverse, currency, desCurrency) {
        this.isLoadingRate = true;
        let rate = this.exchangeRateTodayReference;
        this.reverseCalculator = reverse;

        const payload = {
          amount: amount,
          rate: rate,
          reverse: this.reverseCalculator,
          sEnterpriseId: this.$route.params.sEnterpriseId
        };

        try {
          DB.post(`${URI}/api/v1/en/administrator/calculatorAmount`, payload, {
            headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : "",
              },
          })
          .then((response) => {
            const result = parseFloat(response.data.data.result);
            this.exchangeRateToday = response.data.data.rate;
            this.amounts[this.reverseCalculator ? currency : desCurrency] = this.roundHalfEven(result, 2).toFixed(2);
          })
          .catch((error) => {
            console.log(error);
            this.mixError(error.response.data.message, error.response.status);
          })
          .finally(() => {
            this.isLoadingRate = false;
          });
        } catch (error) {
          this.mixError(error.response.data.message, error.response.status);
        }
      },
      async getRate(originCurrency, destCurrency) {
        this.isLoadingRate = true;
        this.exchangeRateToday = null;
        this.exchangeRateTodayReference = null;
        this.amounts = { USD: 0, MXN: 0 };

        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          currency: originCurrency,
          desCurrency: destCurrency,
        };

        if (originCurrency != destCurrency) {
          DB.post(`${URI}/api/v1/en/administrator/getExchangeRate`, payload, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
          })
          .then((response) => {
            this.exchangeRateToday = response.data.exchangeRateToday;
            this.exchangeRateTodayReference = response.data.exchangeRateTodayReference;
            this.mixSuccess(response.data.message);
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          })
          .finally(() => {
            this.isLoadingRate = false;
          });
        }
      },
      async sendPayment() {
        this.loadingPayment = true;
        this.paymentError = null;
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          dOriginAmount: this.amounts[this.selectedCurrency],
          dDestAmount: this.amounts[this.supplier?.sAccountCurrency],
          dOriginCurrency: this.selectedCurrency,
          dDestCurrency: this.supplier?.sAccountCurrency,
          comment: this.comment,
          sPaymentRecipientId: this.supplier?.sPaymentRecipientId,
          sExchangeRateReference: this.exchangeRateTodayReference,
          reverse: this.reverseCalculator,
          selectedTypeOfPayment: this.selectedTypeOfPayment,
          sTransactionId: this.sTransactionId ? [this.sTransactionId] : []
        };

        try {
          const response = await DB.post(
            `${URI}/api/v1/en/administrator/createPayment`,
            payload,
            { headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""}}
          );
          this.mixSuccess(response.data.message);
          this.$emit('wallets:update');
          this.payment = response.data.payment;
          this.paymentError = false;
        } catch (error) {
          this.paymentError = true;
          this.mixError(error.response.data.message, error.response.status);
        } finally {
          this.loadingPayment = false;
        }
      },
      roundHalfEven(num, decimals = 2) {
        const factor = Math.pow(10, decimals);
        const temp = num * factor;
        const floor = Math.floor(temp);
        const diff = temp - floor;

        if (diff === 0.5) {
          return (floor % 2 === 0 ? floor : floor + 1) / factor;
        }

        return Math.round(temp) / factor;
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      getTransactionTypeName(id) {
        switch (id) {
          case 'b80e8dc6-4138-449e-8903-968efb8437b3': return 'Forward';
          case 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a': return 'Spot';
          case '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf': return 'Window spot';
          default: return 'N/A';
        }
      },
      dataXLSXActiveConversions() {
        try {
          const data = this.activeConversionsRaw.map((item) => ({
            "ID de seguimiento": item.sTransactionId || "-",
            "Fecha de creación": item.created_at ? this.formatDate(item.created_at) : "-",
            "Tipo de transacción": this.getTransactionTypeName(item.sTransactionType),
            "Tipo de cambio": `$ ${this.formatMoney(item.dExchangeRate < 1 ? 1 / item.dExchangeRate : item.dExchangeRate)} MXN`,
            "Monto origen": `${this.formatMoney(item.dAmount)}`,
            "Monto destino": `${this.formatMoney(item.dDesAmount)}`,
            "Currency Origen": item.sCurrency || 'USD',
            "Currency Destino": item.sDestCurrency || 'MXN',
          }));

          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Conversiones Disponibles");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          saveAs(blob, "ConversionesDisponibles.xlsx");

          this.success = true;
          this.msgSuccess = "Descargando conversiones disponibles";
        } catch (error) {
          console.error("Error al generar XLSX de conversiones disponibles:", error);
          this.error = true;
          this.codeError = "XLSX_ACTIVE_CONVERSIONS_FAILED";
        }
      },
    }
  };
</script>
<style scoped>
  .info-card {
    border: 1px #bbbbbb solid;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.35) !important;
    background-color: white;
    border-radius: 20px !important;;
    padding: 16px;
  }

  .info-block {
    background-color: #F2F2F2;
    border-radius: 10px !important;
    padding: 8px;
    margin-bottom: 10px;
  }

  .label {
    color: #868DA6;
    font-family: "montserrat-bold";
    font-size: 14px;
    margin-bottom: 2px;
    padding: 5px 5px;
    width: fit-content;
    display: flex;
    align-items: center;
  }

  .value {
    color: black;
    font-family: "montserrat-bold";
    font-size: 16px;
    padding: 5px 5px;
    margin-bottom: 2px;
    width: fit-content;
    display: flex;
    align-items: center;
  }
</style>